import { blockedSkuUnavailableMap } from "./menuSkuPolicy";

const normalizeSku = (value) => String(value || "").trim();

export const AVAILABILITY_ERROR_CODES = {
  SOLD_OUT_ITEMS: "sold_out_items",
  AVAILABILITY_CHECK_FAILED: "availability_check_failed",
};

export function buildSoldOutLookup(soldOutItems = {}) {
  const entries = Array.isArray(soldOutItems)
    ? soldOutItems
    : Object.values(soldOutItems || {});

  return entries.reduce((lookup, item) => {
    const skuCode = normalizeSku(item?.skuCode);
    if (skuCode) {
      lookup[skuCode] = item || { skuCode };
    }
    return lookup;
  }, blockedSkuUnavailableMap());
}

export function findInvalidCartItems(items = [], soldOutItems = {}) {
  const soldOutLookup = buildSoldOutLookup(soldOutItems);

  return (Array.isArray(items) ? items : []).reduce((invalid, item) => {
    const matches = [];
    const itemSku = normalizeSku(item?.skuCode);

    if (itemSku && soldOutLookup[itemSku]) {
      matches.push({
        type: "item",
        skuCode: itemSku,
        name: item?.name || item?.shortName || item?.longName || "",
        soldOutName:
          soldOutLookup[itemSku]?.longName ||
          soldOutLookup[itemSku]?.shortName ||
          soldOutLookup[itemSku]?.skuCode ||
          itemSku,
      });
    }

    (Array.isArray(item?.selectedOptions) ? item.selectedOptions : []).forEach((option) => {
      const optionSku = normalizeSku(option?.skuCode);
      if (!optionSku || !soldOutLookup[optionSku]) return;

      matches.push({
        type: "option",
        skuCode: optionSku,
        name: option?.title || option?.name || "",
        soldOutName:
          soldOutLookup[optionSku]?.longName ||
          soldOutLookup[optionSku]?.shortName ||
          soldOutLookup[optionSku]?.skuCode ||
          optionSku,
      });
    });

    if (matches.length > 0 && item?.id) {
      invalid[item.id] = {
        id: item.id,
        itemId: item.itemId || "",
        skuCode: itemSku,
        name: item.name || item.shortName || item.longName || "",
        matches,
      };
    }

    return invalid;
  }, {});
}

export function hasInvalidCartItems(invalidCartItems = {}) {
  return Object.keys(invalidCartItems || {}).length > 0;
}
